import { render, staticRenderFns } from "./OrganisationDataUpload.vue?vue&type=template&id=3becb9bc&"
import script from "./OrganisationDataUpload.vue?vue&type=script&lang=js&"
export * from "./OrganisationDataUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports